import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import TranslateIcon from '@mui/icons-material/Translate';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import MicIcon from '@mui/icons-material/Mic';

import CropFreeIcon from '@mui/icons-material/CropFree';
import LayersIcon from '@mui/icons-material/Layers';
import AddchartIcon from '@mui/icons-material/Addchart';

import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import TextIncreaseIcon from '@mui/icons-material/TextIncrease';

export const editorLangPtStrs = {

    /** Updated at 01.12.2025 */

    /** Updated at 01.12.2025 */
    //Hero component
    chip_label: "Novo: Poderosa Suíte de Edição de Vídeo com IA",
    main_headline_part_1: "Seu Espaço de Trabalho ",
    main_headline_part_2: "de Vídeo em Nuvem",
    main_headline_part_3: "Tudo-em-Um.",
    main_headline_part_4: "Edite Tudo. Em Qualquer Lugar.",
    main_subtitles: "Criação avançada de vídeo com IA no seu navegador: converta horizontal para vertical, edite cenas automaticamente, rastreie rostos e preserve a identidade do falante com dublagem de IA de última geração.",
    feature_cards: [
        {
            icon: <AutoAwesomeIcon fontSize="large" sx={{ color: '#00BCD4' }}/>,
            title: "Gerador Viral com IA",
            description: "Crie shorts virais com rastreamento facial a partir de vídeos longos em segundos."
          },
          {
            icon: <MicIcon fontSize="large" sx={{ color: '#9C27B0' }}/>,
            title: "Clonagem de Voz e Dublagem",
            description: "Duble em mais de 40 idiomas mantendo a identidade vocal original."
          },
          {
            icon: <TranslateIcon fontSize="large" sx={{ color: '#2196F3' }}/>,
            title: "Legendas Auto e Tradução",
            description: "Legendas com 99% de precisão e tradução instantânea."
          },
          {
            icon: <AddAPhotoIcon fontSize="large" sx={{ color: '#E91E63' }}/>,
            title: "Suíte de IA Generativa",
            description: "Text-to-Speech (TTS) e Geração de Imagem com IA integrados."
          }
    ],
    start_editing_button: "Começar a Editar →",
    ai_dubbing_button: "Testar Dublagem com IA (Beta)",
    workspace_preview: "Prévia do Espaço de Trabalho",
    //Discover
    discover_ai_shorts_features: [
        {
          icon: <CropFreeIcon fontSize="large" sx={{ color: '#00BCD4' }}/>,
          title: "Rastreamento Facial com IA",
          description: "O reenquadramento inteligente mantém o falante perfeitamente centralizado no formato vertical 9:16."
        },
        {
          icon: <LayersIcon fontSize="large" sx={{ color: '#9C27B0' }}/>,
          title: "Geração em Lote",
          description: "Envie um vídeo de 60 minutos e obtenha mais de 40 shorts totalmente editados e legendados instantaneamente."
        },
        {
          icon: <AddchartIcon fontSize="large" sx={{ color: '#2196F3' }} />,
          title: "Pontuação de Viralidade",
          description: "Nossa IA classifica os clipes com base no potencial de engajamento para que você poste apenas o melhor."
        }
    ],
    discory_label: "⚡ O MULTIPLICADOR DE CONTEÚDO",
    discovery_left_headline_1: "Um Vídeo Horizontal.",
    discovery_left_headline_2: "40+ Shorts Virais.",
    disocry_left_headline_3: "Não deixe seu podcast ou conteúdo do YouTube acumular poeira. A Kedy.ai identifica automaticamente ganchos virais, reenquadra o falante ativo e gera clipes verticais envolventes em minutos.",
    discovery_CTA_button: "Transforme 1 Vídeo em 10 Shorts Agora →",
    discovery_video_mockups_1: "SÉRIE ORIGINAL",
    discovery_video_mockups_2: "A Revolução Tech",
    discovery_video_mockups_3: "T4 • E2",
    discovery_video_mockups_4: "ISSO É LOUCURA! 🤯",

    // Other tools
    other_tools_features: [
        {
          icon: <MicIcon fontSize="large" sx={{ color: '#9C27B0' }}/>,
          title: "Clonagem de Voz Real",
          description: "Analisamos sua impressão vocal única para criar uma versão dublada que soa exatamente como você."
        },
        {
          icon: <ChatBubbleIcon fontSize="large" sx={{ color: '#E91E63' }}/>,
          title: "Sincronia Labial Perfeita (Beta)",
          description: "O vídeo é sutilmente ajustado para corresponder aos movimentos labiais do novo idioma para uma aparência natural."
        },
        {
          icon: <TextIncreaseIcon fontSize="large" sx={{ color: '#2196F3' }}/>,
          title: "Tradução Contextual",
          description: "Gírias, expressões idiomáticas e termos técnicos são traduzidos com precisão para manter o significado original."
        }
    ],

    other_tools_right_side_label:"🎙️ ESTÚDIO DE VOZ GLOBAL",
    other_tools_headline:"Torne-se Global.",
    speak_local:"Fale Local.",
    ai_dubbing_explanation: "Quebre barreiras linguísticas sem perder sua identidade. Nosso motor de Dublagem com IA traduz seu conteúdo para mais de 40 idiomas, preservando sua voz, emoção e entonação originais.",
    other_tools_CTA_button: "Clonar Minha Voz e Dublar",
    global_reach_badge_1: "Clonagem de Voz",
    global_reach_badge_2: "98% de Precisão",
    global_reach_badge_3: "Alcance Global",
    global_reach_badge_4: "40+ Idiomas Suportados",

    // Social
    social_left_menu_badge: "INTEGRAÇÃO PERFEITA",
    social_left_menu_title_1: "Conecte todo o seu",
    social_left_menu_title_2: "ecossistema criativo.",
    social_left_menu_explanation: "Não perca tempo baixando e enviando novamente. O Kedy.ai conecta-se diretamente às suas plataformas favoritas para publicação em um clique e sincronização de ativos.",
    social_features: [
      {
        title: "Agendamento Inteligente",
        desc: "Planeje com antecedência. Selecione datas e horários específicos para o seu conteúdo ir ao ar.",
        color: '#22d3ee'
      },
      {
        title: "Upload Direto de Vídeo",
        desc: "Envie vídeos em 4K diretamente do seu dispositivo para o editor na nuvem.",
        color: '#a78bfa'
      },
      {
        title: "Gerenciamento Seguro de API",
        desc: "Criptografia de nível empresarial para todas as suas contas conectadas.",
        color: '#34d399'
      }
    ],
    social_right_menu_title: "Chaves de API e Conexões",

    // Carousel
    loved_by_creators_1: "Amado por",
    loved_by_creators_2: "Criadores",
    loved_by_creators_3: "Automatizando fluxos de trabalho para os melhores do mercado.",
    carousel_button_1: "Comece grátis",
    carousel_button_2: "Agendar demo",

    /** Updated at 01.12.2025 */


    "welcomNewProject": "Bem-vindo ao seu novo projeto",
    "pls_add_media": "Por favor, adicione mídia ao seu projeto",
    "add_video": "Adicionar Vídeo",
    "add_audio": "Adicionar Áudio",
    "add_image": "Adicionar Imagem",
    "add_webcam": "Captura de Webcam",
    "add_screen": "Captura de Tela",
    "add_webcam_screen": "Captura de Webcam & Tela",
    "capture_screen_camera": "Capture sua tela & câmera!",
    "video_captureDevice": "Dispositivo de Captura de Vídeo",
    "resolution": "Resolução",
    "audio_captureDevice": "Dispositivo de Captura de Áudio",
    "resize_video": "Redimensionar Vídeo",
    "rotate_video": "Rotacionar Vídeo",
    "loop_video": "Loop de Vídeo",
    "joinmarge_video": "Adicionar Junção/Mesclagem de Vídeo",
    "cut_video": "Cortar Vídeo",
    "crop_video": "Recortar Vídeo",
    "translate_video": "Traduzir Vídeo",
    "transcripbe_video": "Transcrever Vídeo",
    "auto_subtitles": "Legendas Automáticas",
    "add_subtitle_video": "Adicionar Legenda ao Vídeo",
    "compress_video": "Comprimir Vídeo",
    "convert_video": "Converter Vídeo",
    "project_not_accessible": "Projeto não acessível",
    "continue": 'Continuar',
    "leave": "Sair",
    "cancel": "Cancelar",
    "submit": "Enviar",
    "okay": "Ok",
    "stop": "Parar",
    "record": "Gravar",
    "ongoing_upload_project_str": "Há um carregamento em andamento para este projeto.",
    "leaving_page_sure": "Você está saindo desta página, tem certeza?",
    "uploading_files": "Carregando Arquivos",
    "record_screen_and_upload": "Grave sua tela e faça o upload.",
    "show_defaul_sharingMenu": "Mostrar itens de menu de compartilhamento padrão",
    "prefer_share_browser": "Preferir compartilhar uma aba do navegador",
    "prefer_share_window": "Preferir compartilhar uma janela",
    "prefer_share_entireScreen": "Preferir compartilhar a tela inteira",
    "record_webcam_and_upload": "Grave sua webcam e faça o upload.",
    "sign_signup_to_uploadVideos": "Por favor, faça login ou cadastre-se para fazer upload de vídeos",
    "sizelimir_or_timelimit": "maior que 250 Mbytes ou mais longo que 5 minutos",
    "screen_capture_preferences": "Preferências de Captura de Tela",
    "is_uploading": "Está Carregando",
    "monthly": "Mensal",
    "annually": "Anual",
    "most_popular": "Mais Popular",
    "export": "Exportar",
    "bitrate": "Taxa de Bits",
    "frame_rate_fps": "Taxa de Quadros (FPS)",
    "produce": "Produzir",
    "setup": "Configuração",
    "template": "Modelo",
    "templates": "Modelos",
    "media": "Mídia",
    "stock": "Estoque",
    "translations": "Traduções",
    "subtitles": "Legendas",
    "text_to_speech": "Texto para Fala",
    "transitions": "Transições",
    "text": "Texto",
    "emojis": "Emojis",
    "filters": "Filtros",
    "draw": "Desenhar",
    "edit_subtitle": "Editar Legenda",
    "add_new_subtitle": "adicionar nova legenda",
    "select_brush_stock_start_draw": "Selecione um pincel para começar a desenhar",
    "brush_stroke": "Pincelada",
    "round": "Redondo",
    "sliced": "Fatiado",
    "color": "Cor",
    "opacity": "Opacidade",
    "size": "Tamanho",
    "duration": "Duração",
    "add_new_line": "Adicionar Nova Linha",
    "all_types": "Todos os Tipos",
    "load_more": "Carregar Mais",
    "upload_video": "Fazer Upload de Vídeo",
    "upload_audio": "Fazer Upload de Áudio",
    "upload_image": "Fazer Upload de Imagem",
    "create_webcam_recording": "Criar Gravação de Webcam",
    "create_screen_capture_recording": "Criar Gravação de Captura de Tela",
    "create_webcam_screen_recording": "Criar Gravação de Webcam & Tela",
    "project_asset": "Ativo do Projeto",
    "you_want_add_translations": "Como você deseja adicionar traduções?",
    "uploader": "Uploader",
    "auto": "AUTO",
    "auto_translations": "Traduções Automáticas",
    "automatically_add_transllations_video": "Adicionar traduções automaticamente ao vídeo",
    "wait_moments_subtitles_being": "Aguarde alguns momentos enquanto a legenda está sendo preparada",
    "select_language_detect": "Selecione a língua para detectar",
    "select_different_target_language": 'Escolha um idioma de destino diferente',
    "select_different_source_and_target_languages": 'Os idiomas de origem e de destino não podem ser iguais',
    "voice_clones": "Clones de voz",
    "source_language": "Idioma de origem",
    "select_source_language": "Selecione o idioma de origem",
    "select_target_language": "Selecionar idioma de destino",
    "redub_another_language": 'Re-Dub com outro idioma',
    "upload_new_file": 'Carregar Novo Ficheiro',
    "no_title": 'Sem Título', 
    "unknown": 'Desconhecido',
    "watch_video": 'Assistir Vídeo',
    "listen_audio": 'Ouvir Áudio',
    "video_preparing": 'Preparando Vídeo',
    "audio_preparing": 'Preparando Áudio',
    "delete_voice_clone": 'Excluir Clone de Voz',
    "delete_voice_clone_assets": 'Excluir Clone de Voz com Ativos',
    "no_voice_clones": "Nenhum clone de voz para exibir",  
    "upload_file_to_create_first_voice_clone": "Envie um arquivo para criar seu primeiro clone de voz e superar a barreira do idioma",
    "disable_translate": "Desativar Tradução",
    "select_language_select": "Selecione a Língua para traduzir",
    "transition_duration": "Duração da Transição",
    "coming_soon": "Em Breve",
    "language": "Idioma",
   "english": "Inglês",
    "spanish": "Espanhol",
    "french": "Francês",
    "german": "Alemão",
    "italian": "Italiano",
    "portuguese": "Português",
    "polish": "Polonês",
    "turkish": "Turco",
    "russian": "Russo",
    "dutch": "Holandês",
    "czech": "Tcheco",
    "arabic": "Árabe",
    "chinese": "Chinês",
    "hungarian": "Húngaro",
    "korean": "Coreano",
    "japanese": "Japonês",
    "hindi": "Hindi",
    "danish": "Dinamarquês",
    "greek": "Grego",
    "finnish": "Finlandês",
    "hebrew": "Hebraico",
    "malay": "Malaio",
    "norwegian": "Norueguês",
    "swedish": "Sueco",
    "swahili": "Suaíli",
    "speaking_rate_defaul": "Taxa de Fala (padrão 1)",
    "pitch_defaul": "Tom (padrão 0)",
    "volume_gain_default": "Ganho de Volume (padrão 0)",
    "create_text_speech": "Criar Texto para Fala",
    "add_text": "Adicionar Texto",
    "text": "Texto",
    "start": "Início",
    "end": "Fim",
    "text_style": "Estilo do Texto",
    "background_color": "Cor de Fundo",
    "add_new_text_field": "Adicionar Novo Campo de Texto",
    "how_add_subtitles": "Como você deseja adicionar legendas",
    "automatically_subtitles_video": "Adicionar legendas automaticamente ao vídeo",
    "text_color": "Cor do Texto",
    "preview_text": "Pré-visualizar Texto",
    "search": "Buscar",
    "orientation": "Orientação",
    "next": "Próximo",
    "previous": "Anterior",
    "first": "Primeiro",  
    "last": "Último",
    "locale": "Localidade",
    "landscape": "Paisagem",
    "portrait": "Retrato",
    "square": "Quadrado",
    "time": "Tempo",
    "background": "Fundo",
    "project_setting": "Configurações do Projeto",
    "use_template_project": "Usar como modelo de projeto",
    "visibility": "Visibilidade",
    "category": "Categoria",
    "capture_thumbnail": "Capturar Miniatura",
    "brand_kit": "Kit de Marca",
    "video_placeholder": "EspaçoReservadoParaVídeo2.mp4",
    "replace_video": "Substituir Vídeo",
    "transformations": "Transformações",
    "fill_canvas": "Preencher a tela",
    "fit_canvas": "Ajustar à tela",
    "round_corners": "Cantos Arredondados",
    "audio": "Áudio",
    "detach_audio": "Desanexar Áudio",
    "cleanAudio": "LimparÁudio",
    "upgrade_basic_unlock": "Upgrade para BASIC para desbloquear",
    "remove_background_noise_enhance_audio_qty": "Remover ruído de fundo e melhorar qualidade do áudio",
    "color_correction": "Correção de Cor",
    "reset": "Resetar",
    "exposure": "Exposição",
    "brightness": "Brilho",
    "contract": "Contraste",
    "saturation": "Saturação",
    "sharpen": "Afiar",
    "blur": "Desfocar",
    "noise": "Ruído",
    "trending": "TENDÊNCIAS",
    "custom": "PERSONALIZADO",
    "portrait": "RETRATO",
    "landscape": "PAISAGEM",
    "settings": "Configurações",
    "magic_draw": "Desenho Mágico",
    "tools": "Ferramentas",
    "brush_size": "Tamanho do Pincel",
    "save": "Salvar",
    "clear": "Limpar",
    "view_all": "Ver Tudo",
    "save_your_project_later": "Salve seu projeto para mais tarde",
    "sign_in": "entrar",
    "sign_up": "cadastrar-se",
    "sign_up_home": "Cadastre-se",
    "redo": "REFAZER",
    "undo": "DESFAZER",
    "collaborate": "COLABORAR",
    "enter_email_share_project": "Digite o email para compartilhar o projeto",
    "share_project": "Compartilhar Projeto",
    "create_new_workspace": "Criar novo Espaço de Trabalho",
    "audio_noise_remove": "Remoção de Ruído de Áudio",
    "media_upload": "Upload de Mídia",
    "draw_color": "Cor do Desenho",
    "tsl_none": "nenhum",
    "tsl_fade": "Desvanecer",
    "tsl_book_flip": "Virar Livro",
    "tsl_disolve": "Dissolver",
    "tsl_doorway": "Porta",
    "tsl_blur": "Borrar",
    "tsl_push": "Empurrar",
    "tsl_slide": "Deslizar",
    "tsl_wipe": "Limpar",
    "tsl_zoom_in": "Zoom In",
    "tsl_zoom_out": "Zoom Out",
    "flt_None": "Nenhum",
    "flt_Darker": "Mais Escuro",
    "flt_BlacknWhite": "Preto e Branco",
    "flt_Daphne": "Dafne",
    "flt_Penelope": "Penélope",
    "flt_Phoebe": "Febe",
    "flt_Thalia": "Tália",
    "flt_Chloe": "Cloe",
    "flt_Hermione": "Hermione",
    "flt_Hera": "Hera",
    "flt_Rhea": "Reia",
    "flt_Donna": "Donna",
    "flt_Martina": "Martina",
    "flt_Gabriella": "Gabriela",
    "flt_Elisabetta": "Elisabetta",
    "flt_Isabella": "Isabella",
    "flt_Luna": "Luna",
    "flt_Viola": "Viola",
    "flt_Zita": "Zita",
    "flt_Donata": "Donata",
    "flt_Maddalena": "Maddalena",
    "flt_Tecla": "Tecla",
    "flt_Narcisa": "Narcisa",
    "emj_Smileys": "Sorrisos",
    "emj_Animals": "Animais",
    "emj_People": "Pessoas",
    "emj_Jobs": "Trabalhos",
    "emj_Sports": "Esportes",
    "emj_Flags": "Bandeiras",
    "emj_Signs": "Sinais",
    "emj_Nature": "Natureza",
    "emj_Travel": "Viagem",
    "emj_Letters": "Letras",
    "emj_Misc": "Diversos",
    "create_empty_project_templates": "Criar um Projeto Vazio a partir de Modelos",
    "days_ago": "dias atrás", 
    "hours_ago": "horas atrás",
    "minutes_ago": "minutos atrás",
    "seconds_ago": "segundos atrás",
    "create_workspace": "Criar Espaço de Trabalho",
    "workspace": "Espaços de Trabalho",
    "delete_workspace": "Deletar Espaço de Trabalho",
    "transfer_owner": "Transferir Proprietário",
    "can_create_new_workspace": "Pode criar novo espaço de trabalho?",
    "could_delete_workspace": "Poderia deletar o espaço de trabalho?",
    "available_subtitles_time": "Tempo de Legendas Disponível",
    "available_storage_space": "Espaço de Armazenamento Disponível",
    "available_text_to_speech": "Texto para Fala Disponível",
    "other_workspaces": "Outros espaços de trabalho",
    "members": "Membros",
    "add_member": "Adicionar Membro",
    "remove_member": "Remover Membro",
    "change_member_level": "Mudar Nível do Membro",
    "owner": "Proprietário",
    "admin": "Administrador",
    "member": "Membro",
    "read_only": "Somente Leitura",
    "duplicate": "Duplicar",
    "splite": "Dividir",
    "remove": "remover",
    "layer": "Camada",
    "volume": "Volume",
    "disable": "Desativar",
    "deleterow": "DeletarLinha",
    "fullscreen": "Tela Cheia",
    "editsubtitle": "EditarLegenda",
    "fit": "Ajustar",
    "green_screen": "Tela Verde",
    "profile": "Perfil",
    "contact_us": "Contate-Nos",
    "pricing": "Preços",
    "login": "Entrar",
    "logout": "Sair",
    "get_started_free": "Comece - é grátis",
    "dashboard": "Painel",
    "projects": "Projetos",
    "menu_Features": "Recursos",
    "menu_Tools": "Ferramentas",
    "menu_VideoEditor": "Editor de Vídeo",
    menu_AIVideoEditor: "Editor de Vídeo IA",
    "menu_AddImgToVideo": "Adicionar Imagem ao Vídeo",
    "menu_AddMusicToVideo": "Adicionar Música ao Vídeo",
    "menu_AddTextToVideo": "Adicionar Texto ao Vídeo",
    "menu_FilterVideo": "Filtrar Vídeo",
    "menu_AddTransitionstoVideo": "Adicionar Transições ao Vídeo",
    "menu_AddFreeStockVideos": "Adicionar Vídeos de Stock Gratuitos",
    "menu_SubtitlesTranscription": "Legendas & Transcrição",
    "menu_AddSubtitlesToVideo": "Adicionar Legendas ao Vídeo",
    "menu_AudioToText": "Áudio para Texto",
    "menu_AutoSubtitles": "Legendas Automáticas",
    "menu_TranscribeVideo": "Transcrever Vídeo",
    "menu_TranslateVideo": "Traduzir Vídeo",
    "menu_Toolkit": "Caixa de Ferramentas",
    "menu_Crop": "Cortar",
    "menu_Cut": "Recortar",
    "menu_JoinMerge": "Juntar / Mesclar",
    "menu_LoopVideo": "Vídeo em Loop",
    "menu_Resize": "Redimensionar",
    "menu_Rotate": "Rotacionar",
    "menu_More": "Mais",
    "menu_VideoCompressor": "Compressor de Vídeo",
    "menu_VideoConverter": "Conversor de Vídeo",
    "menu_AIGenerated": "Gerado por IA",
    "menu_AIGeneratedImages": "Imagens Geradas por IA",
    "menu_AIGeneratedVideos": "Vídeos Gerados por IA",
    "menu_AIGeneratedVoices": "Vozes Geradas por IA",
    "menu_Blog": "Blog",
    "menu_VIDEOOBlog": "Blog Kedy.AI",
    "menu_VIDEOOHowTo": "Como fazer Kedy.AI",
    "menu_VIDEOOCareers": "Carreiras Kedy.AI",
    "try_autosubtitles_in_english": 'Experimente Legendas Automáticas em Inglês',
    "try_translations_in_turkish": 'Experimente Traduções em Turco',
    "try_subtitles_in_spanish": 'Experimente Legendas em Espanhol',
    "try_ai_video_summary": 'Experimente Resumo de Vídeo IA',
    "online_ai_video_editor": "Editor de Vídeo Online Baseado em IA",
    "online_could_video_editor": "Editor de Vídeo Online Baseado em Nuvem",
    "home_free_trial_detail": 'Teste grátis de 7 dias, cancele a qualquer momento',
    "home_create_button_detail": "Criação de vídeo com um clique com legendas automáticas, tradução e mais",
    "create_now": "Criar Agora",
    "home_templates_start": "Explore uma gama de modelos para começar",
    "try_now_required": "Experimente agora, não é necessário conta",
    "online_collaborative_video_editing": "Edição de Vídeo Colaborativa Online",
    "online_collaborative_video_editing_detail": "Mergulhe no mundo da Edição de Vídeo Online Baseada em Nuvem com kedy.ai. Nossa plataforma revoluciona a maneira como você edita, oferecendo capacidades de Edição de Vídeo Colaborativa Online e um Espaço de Trabalho de Edição de Vídeo Baseado em Nuvem.",
    "auto_subtitles_translations": "Legendas e Traduções Automáticas",
    "auto_subtitles_translations_detail": "Aprimore seus vídeos com nosso recurso de Legendas e Traduções Automáticas, parte do nosso Software de Edição de Vídeo Online Profissional. Projetado para ser uma Ferramenta de Software de Edição de Vídeo para Todos, kedy.ai torna simples criar conteúdo acessível e cativante.",
    "ai_base_text_speech": "Texto para Fala Baseado em IA",
    "ai_base_text_speech_detail": "Nossas Vozes de Texto para Fala Baseadas em IA são perfeitas para criadores de conteúdo, encarnando o conceito de Edição de Vídeo Reinventada para Youtubers e Influenciadores. Com kedy.ai, transforme seus scripts em voiceovers envolventes, adicionando um toque profissional aos seus vídeos e simplificando seu processo de produção.",
    "free_user_stock_video": "Vídeos de Stock Gratuitos para Usar",
    "free_user_stock_video_detail": "Acesse uma vasta coleção de Vídeos de Stock Gratuitos para Usar com kedy.ai, complementando nossas capacidades de Edição de Vídeo 4K Online. Nossa plataforma, sendo um Software de Edição de Vídeo 4K para Todos, garante que seus projetos se destaquem com filmagens de alta qualidade, tornando a edição de nível profissional acessível a todos os usuários.",
    "share": "Compartilhar",
    "unlisted_video": "Vídeo Não Listado",
    "your_video_about_ready": "Seu vídeo está quase pronto",
    "hours": "Horas",
    "minutes": "Minutos",
    "seconds": "Segundos",
    "want_free_stuff": "Quer coisas grátis?",
    "record_screen_webcam_both": "Grave sua tela, webcam ou ambos",
    "add_subtitle_your_video": "Adicione legendas aos seus vídeos",
    "create_your_team_workspace": "Crie seu Espaço de Trabalho em Equipe",
    "collaborate_videos": "Colabore em vídeos",
    "generate_transcript": "Gerar transcrição",
    "singup_get_all_this_more": "Inscreva-se (de graça) para obter tudo isso e mais!",
    "downloading": "Baixando",
    "download": "Baixar",
    "reedit_video": "Reeditar vídeo",
    "remove_watermark": "Remover marca d'água",
    "already_have_account": "Já tem uma conta?",
    "link_copied": "Link Copiado",
    "invitation_list": "Lista de Convites",
    "remove_invitation": "Remover Convite",
    "change_workspace": "Mudar espaço de trabalho",
    "you_login_manage_your_profile": "Você precisa fazer login para gerenciar seu perfil",
    "you_dont_have_content_here": "Você não tem nenhum conteúdo aqui.",
    "name": "Nome",
    "status": "Status",
    "data_modified": "Data Modificada",
    "all_workspaces": "Todos os Espaços de Trabalho",
    "delete_project": "Deletar Projeto",
    "duplicate_project": "Duplicar Projeto",
    "draft": "Rascunho",
    "edit": "Editar",
    "surname": "Sobrenome",
    "email": "E-mail",
    "plan": "Plano",
    "market_emails": "E-mails de Marketing",
    "editor_notification": "Notificações do Editor",
    "storage": "Armazenamento",
    "subtitle": "Legenda",
    "delete_account": "Deletar Conta",
    "this_action_irreversibe": "Esta ação é irreversível",
    "current_plan": "PLANO ATUAL",
    "cancel_subscription": "Cancelar Assinatura",
    "payment_method": "MÉTODOS DE PAGAMENTO",
    "expires": "Expira",
    "make_default": "Tornar Padrão",
    "delete": "Deletar",
    "add_payment_method": "Adicionar Método de Pagamento",
    "billing_information": "INFORMAÇÕES DE FATURAMENTO",
    "invoice_history": "HISTÓRICO DE FATURAS",
    "payment": "Pagamento",
    "preferences": "Preferências",
    "save_up_to": "Economize Até",
    "your_plan": "Seu Plano",
    "inactive": "Inativo",
    "contact_sales": "Contatar Vendas",
    "need_additional_features": "Precisa de recursos adicionais? Pergunte-nos sobre nosso plano Empresarial",
    "your_online": 'Seu Editor Online',
    "ai_video_editor": 'Editor de Vídeo com IA',
    "screen_and_cam_recorder": 'Gravador de Tela e Câmera',  
    "subtitle_translation": 'Tradução de Legendas',
    "one_click_post_production": 'Pós-produção com um clique',
    "integrations": 'Integrações',
    "custom_privacy_and_security": 'Privacidade e Segurança Personalizadas',
    "while_pet_your_cat": 'Enquanto você acaricia seu gato / saboreia seu café',
    "try_for_free": 'Teste Grátis',
    "subtitles": 'Legendas',
    "audio_noise_removal": 'Remoção de Ruído de Áudio',
    "workflow_tools": 'Ferramentas de Fluxo de Trabalho',
    "corporate_add_ons": 'Complementos Corporativos',
    "video_player": 'Reprodutor de Vídeo',
    "share_and_embed": 'Compartilhar e Incorporar',
    "video_export_length": "Duração máxima de exportação de vídeo",
    "the_basics": "O Básico",
    "support": "Suporte",
    "storage": "Armazenamento",
    "custom_templates":'Modelos Personalizados',
    "ai_video_editor": 'Editor de Vídeo com IA',
    "one_click_post_production": 'Pós-produção com um clique',
    "while_pet_your_cat": 'Enquanto você acaricia seu gato / saboreia seu café',
    "no_watermark": "Sem Marca d'Água",
    "tip_no_watermark": "Se o vídeo tem uma marca d'água ou não",
    "upload_file_size": "Tamanho do arquivo para upload",
    "pricing_compare_header": "Compare os Pacotes",
    "pricing_all_plans_description":
        "Todos os planos incluem todos os recursos de edição de vídeo, legendas automáticas, projetos ilimitados e exportações ilimitadas",
    "pricing_apply_coupon": "Aplicar Cupom",
    "pricing_faq_header": "Perguntas Frequentes",
    "upload_file_size_tip": "Tamanho máximo do arquivo que você pode enviar",
    "upload_file_size_unlimited": "Tamanho do arquivo para upload – ilimitado",
    "export_quality_1080p": "Qualidade de exportação – 1080p",
    "video_export_length_tip": "Duração máxima do vídeo que você pode exportar",
    "video_export_length_free": "10 minutos",
    "video_export_length_basic": "25 minutos",
    "video_export_length_pro": "2 horas",
    "video_export_length_business": "2 horas",
    "private_workspaces": 'Espaços de Trabalho Privados',
    "video_compressor": 'Compressor de Vídeo',
    "video_compressor_basic": 'Compressor de Vídeo Básico',
    "video_compressor_pro": 'Compressor de Vídeo Pro',
    "video_compressor_max": 'Compressor de Vídeo Máximo',
    "video_compressor_premium": 'Compressor de Vídeo Premium',
    "convert_video_basic": "Conversor de Vídeo Básico",
     "convert_video_pro": "Conversor de Vídeo Pro",
     "convert_video_max": "Conversor de Vídeo Máximo",
     "convert_video_premium": "Conversor de Vídeo Premium",
    "no_sign_up_required": 'Não é necessário cadastro',
    "your_online_ai_video_editor": 'Seu Editor de Vídeo com IA Online',
    "discover_kedy": "Descubra as ferramentas com IA da Kedy.AI!",
    "create_video_summaries": "Crie resumos de vídeo com IA",
    "video_summary_description": "A Kedy.AI cria seções-chave de vídeos longos com títulos, descrições e downloads fáceis—rápido e sem esforço.",
    "ai_video_dubbing": "Remova a barreira do idioma com dublagem por IA",
    "ai_video_dubbing_description": "A ferramenta de dublagem da Kedy.AI permite que você fale qualquer idioma—mantendo sua própria voz. Basta enviar o vídeo e a IA faz o resto.",
    "ai_shorts_reels_generator": "Gerador de Shorts/Reels com IA",
    "select_options_to_create_shorts": "Selecione opções para criar vídeos Shorts/Reels com IA.",
    "select_ai_shorts_options": "Selecionar opções de Shorts com IA",
    "summarize_your_content_in": "Resuma seu conteúdo em . . .",
    "set_silence_threshold": "Definir o limite de silêncio (em segundos):",
    "more_chapters": "Mais capítulos",
    "less_chapters": "Menos capítulos",
    "set_min_clip_duration": "Definir duração mínima do clipe (em segundos):",
    "set_num_of_chapters": "Definir número total de capítulos:",
    "viral_clips": "Crie clipes virais com o Gerador Viral com IA para redes sociais",
    "viral_clips_description": "Transforme qualquer vídeo em clipes virais impactantes com a magia da Kedy.AI—foco inteligente em rostos, legendas destacadas e conteúdo pronto para compartilhar.",
    "kedy_ai_editor": "O editor da Kedy.AI tem tudo o que você precisa",
    "kedy_offers_essential_video_editor_tools": "A Kedy.AI oferece todas as ferramentas essenciais de um editor de vídeo",
    "create_project": "Criar Projeto",
    "other_ai_tools": "Outras ferramentas modernas com IA",
    "ai_generated_subtitles": "Legendas automáticas geradas por IA",
    "ai_translation": "Tradução com IA",
    "ai_text_to_speech": "Texto para Fala",
    "ai_generated_images": "Imagens geradas por IA",
    "finish_post_production": "Finalize sua pós-produção com apenas alguns cliques!",
    "try_now": "Experimente agora"

}
